import * as React from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import ListItemText from '@mui/material/ListItemText'
import ListItem from '@mui/material/ListItem'
import List from '@mui/material/List'
import Divider from '@mui/material/Divider'

import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import CloseIcon from '@mui/icons-material/Close'
import Slide from '@mui/material/Slide'
import { useTheme } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'

import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import { forwardRef, useImperativeHandle, useState } from 'react'
import { DialogActions, DialogContent, DialogTitle } from '@mui/material'
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const MyDialog3 = ({ title, component, dialogHandler, windowWidth, dialogActions, placeClose }) => {
  const [childHandler, setChildHandler] = React.useState(null)
  const handleOpen = () => {
    dialogHandler[1](true)
  }
  const setCloseHandler = React.useCallback((fn) => {
    setChildHandler(() => fn)
  }, [])

  const handleClose = (event, reason) => {
    if (reason === 'backdropClick') {
      return
    }

    if (childHandler) {
      childHandler(event, reason)
    } else {
      dialogHandler[1](false)
    }

  }

  const componentWithHandler = React.isValidElement(component)
    ? React.cloneElement(component, { setCloseHandler })
    : component

  return (
    <div>
      <Dialog
        open={dialogHandler[0]}
        onClose={handleClose}
        fullWidth
        maxWidth={windowWidth ?? 'xl'}
      >
        <DialogTitle style={{ justifyContent: 'center', alignItems: 'center' }}>
          <Typography variant='h5' align='center' style={{ fontWeight: 'bold' }}>
            {title}
          </Typography>
          {
            placeClose ? (
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null

          }

          <Divider sx={{ mt: 1 }} />
        </DialogTitle>
        <DialogContent>
          {componentWithHandler}
        </DialogContent>
        <DialogActions>
          {
            dialogActions || <></>
          }
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default MyDialog3
